<script setup lang="ts">
import { Page, Section } from "@/components/Ui";
import { HeroAffiliate } from "@/components/Hero";
import {
  BlockPercentAndTitle,
  BlockAffiliateFaq,
  BlockMoreFriendsMoreMoney,
  BlockTextWithIcon
} from "@/components/Blocks";
import { onMounted } from "vue";
import { onEvent } from "~/helpers/events";

const { t } = useI18n();

onMounted(() => {
  onEvent("affiliate page viewed", null, {
    "product name": "affiliate"
  });
});

useSeoMeta({
  title: t("page.affiliate.seo.title"),
  description: t("page.affiliate.seo.description"),
  ogTitle: t("page.affiliate.seo.title"),
  ogDescription: t("page.affiliate.seo.description")
});
</script>

<template>
  <Page :class="$style.root">
    <HeroAffiliate />
    <Section
      :title-class="$style['section-title']"
      :class="$style.section"
      container
    >
      <div :class="[$style[`section-wrapper`], $style.percents]">
        <BlockPercentAndTitle
          :value="90"
          bg="orange"
          :title="t('page.affiliate.percent_1')"
        />
        <BlockPercentAndTitle
          :value="30"
          bg="light"
          :title="t('page.affiliate.percent_2')"
        />
        <BlockPercentAndTitle
          :value="10"
          bg="dark"
        >
          <template #title>
            {{t("page.affiliate.percent_3_1")}}<br /> {{t("page.affiliate.percent_3_2")}}
          </template>
        </BlockPercentAndTitle>
      </div>
    </Section>
    <Section :title-class="$style['section-title']">
      <template #title>
        {{t("page.affiliate.section_1")}}
      </template>
      <BlockMoreFriendsMoreMoney />
    </Section>
    <Section :title-class="$style['section-title']">
      <template #title>
        {{t("page.affiliate.section_2")}}
      </template>
      <div :class="[$style[`section-wrapper`], $style.how]">
        <BlockTextWithIcon
          icon="copy"
          :title="t('page.affiliate.how_1_title')"
          :text="t('page.affiliate.how_1_text')"
        />
        <BlockTextWithIcon
          icon="worldwide"
          :title="t('page.affiliate.how_2_title')"
          :text="t('page.affiliate.how_2_text')"
        />
        <BlockTextWithIcon
          icon="account_top_up"
          :title="t('page.affiliate.how_3_title')"
          :text="t('page.affiliate.how_3_text')"
        />
      </div>
    </Section>
    <Section
      :title-class="$style['section-title']"
      :class="$style.faq"
      full-width
    >
      <template #title>
        {{ $t("page.affiliate.sectionFaqTitle") }}
      </template>
      <div class="container">
        <BlockAffiliateFaq />
      </div>
    </Section>
  </Page>
</template>
<style lang="scss" module>
.root {
  @apply flex flex-col gap-[80px] mt-[70px] md:mt-[90px];
}

.section {
  @apply w-full;
  &-title {
    @apply text-center px-4 font-bold text-[40px] leading-[108%];
  }

  &-wrapper {
    @apply w-full grid grid-cols-1 lg:grid-cols-3;
  }
}

.percents {
  @apply gap-x-10 gap-y-5 md:gap-y-3 max-w-[336px] md:max-w-full;
}

.how {
  @apply gap-3;
}

.faq {
  @apply bg-neutral-900 mt-[80px] pt-[80px] pb-[60px] text-white;
}
</style>
